import { client } from "../libs/client";

export const saveCompleteWill = async (data) => {
  return await client.post("/will", data);
};

export const saveBasicInfo = async (data) => {
  return await client.post("/will/basic-info", data);
};

export const saveFamilyInfo = async (data) => {
  return await client.post("/will/family", data);
};

export const savePetGuardian = async (data) => {
  return await client.post("/will/pet-guardian", data);
};

export const saveAltPetGuardian = async (data) => {
  return await client.post("/will/alt-pet-guardian", data);
};

export const saveChildGuardian = async (data) => {
  return await client.post("/will/child-guardian", data);
};

export const saveAltChildGuardian = async (data) => {
  return await client.post("/will/alt-child-guardian", data);
};

export const saveDistribution = async (data) => {
  return await client.post("/will/distribution", data);
};

export const saveExecutor = async (data) => {
  return await client.post("/will/executor", data);
};

export const savePoaAttorney = async (data) => {
  return await client.post("/will/poa-attorney", data);
};

export const savePoaCare = async (data) => {
  return await client.post("/will/poa-care", data);
};

export const fetchUserWill = async () => {
  return await client.get("/will/me");
};

export const downloadWillPdf = async () => {
  return await client.get("/will/download", { responseType: "blob" });
};

export const downloadPoaCarePdf = async () => {
  return await client.get("/will/poa-care/download", { responseType: "blob" });
};

export const downloadPoaPropertyPdf = async () => {
  return await client.get("/will/poa-property/download", {
    responseType: "blob",
  });
};

export const notifyContact = async (data) => {
  return await client.post("/will/notify", data);
};

export const generateAndEmailPdf = async (docType = "will") => {
  return await client.post("/will/generate-and-email", { docType });
};
